import React from "react";
import { SalesareaProvider } from "../../../old/beheer/views/Upsell/modernTS/salesarea/SalesareaContext";
import { useAppSelector } from "../../../old/beheer/store";
import MainNavbar from "../../../old/beheer/components/Navbars/MainNavbar";
import TranslationWrapper from "../../../old/beheer/components/TranslationWrapper/TranslationWrapper";
import { selectSalesAreaId } from "../../SalesAreas/selectors/selectSalesAreaId";
import SalesAreaPriceLinesView from "./SalesAreaPriceLines/SalesAreaPriceLinesView";
import { DialogProvider } from "../../../old/beheer/views/Upsell/modernTS/JUI/Dialogs";

export default function PriceLinesPage() {
  const salesAreaId = useAppSelector(selectSalesAreaId);

  return (
    <SalesareaProvider salesareaId={salesAreaId}>
      <DialogProvider>
        <MainNavbar paginaTitel={<TranslationWrapper tDefault={"Price lines"} tKey={"price-lines.table.title"} />} />
        {salesAreaId ? <SalesAreaPriceLinesView salesAreaId={salesAreaId} /> : null}
      </DialogProvider>
    </SalesareaProvider>
  );
}
